'use client';

import { type ComponentProps, useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

import { productPageGalleryStore } from './ProductPageGallery.store';

export default function ProductPageGalleryThumbnails({
    className,
    children,
    ...props
}: ComponentProps<'nav'>) {
    const [isHidden, setIsHidden] = useState(false);
    const productPageGalleryPhotoSwipe = productPageGalleryStore(
        (state) => state.photoSwipe,
    );

    useEffect(() => {
        if (!productPageGalleryPhotoSwipe) {
            return;
        }

        productPageGalleryPhotoSwipe.on('beforeOpen', () => {
            setIsHidden(true);
        });

        productPageGalleryPhotoSwipe.on('closingAnimationStart', () => {
            setIsHidden(false);
        });
    }, [productPageGalleryPhotoSwipe]);

    return (
        <nav
            className={cn(
                'flex max-h-full w-16 flex-col gap-2 overflow-y-auto scroll-smooth p-2 transition-opacity duration-300 ease-in-out scrollbar-none max-lg:hidden',
                isHidden ? 'pointer-events-none opacity-0' : '',
                className,
            )}
            {...props}>
            {children}
        </nav>
    );
}
